/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_locale = () => `de-DE`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_pathPrefix = () => `de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_localeLowerCase = () => `de-de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_recaptchaLanguage = () => `de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_timezone = () => `Europe/Berlin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alertBar_dismiss = () => `Nachricht ignorieren/ausblenden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_skipButton_skipContent = () => `Zum Hauptinhalt springen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_currentSlide = () => `Aktuelle Folie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_goToSlide = () => `Gehe zu Folie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_estimated = () => `Geschätzt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_minuteRead = () => `Lesedauer in Minuten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_updated = () => `Aktualisiert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_headline = () => `War dieser Artikel hilfreich?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_yes = () => `Ja`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_no = () => `Nein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_success = () => `Wir haben dein Feedback erhalten. Danke!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_thanks = () => `Wir freuen uns, dass es hilfreich war!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_furtherAssistance = () => `Nutze dieses Formular nur für Feedback zu Artikeln.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_contactSupport = () => `So kontaktierst du den Support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_checkBoxLabel = () => `Zulassen, dass Klaviyo mich wegen meines Feedbacks kontaktiert.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_describe = () => `Beschreibe, was du tun, lernen oder lösen möchtest.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_errorLabel = () => `Achte darauf, dass deine E-Mail-Adresse ein einzelnes @ enthält, gefolgt von einer gültigen Domäne (name@beispiel.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_legend = () => `Danke, dass du uns informiert hast! Erzähle uns mehr über das Problem.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_incompleteLabel = () => `Weitere Details oder Erklärungen nötig`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_irrelevantLabel = () => `Hat nichts damit zu tun, wonach ich gesucht habe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticle = () => `Wie können wir diesen Artikel verbessern?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticleSuggestion = () => `Beschreibe, was dir gefallen hat oder wie der Artikel verbessert werden könnte.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_moreDetail = () => `Könntest du das genauer ausführen?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_submit = () => `Senden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_label = () => `E-Mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_description = () => `Wir werden dich nur wegen deines Feedbacks zu diesem Artikel kontaktieren.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_placeholder = () => `name@beispiel.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_unclearLabel = () => `Unklar, verwirrend oder schwer zu verstehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_wrongLabel = () => `Entspricht nicht der Erfahrung mit dem Produkt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_authorAltText = () => `Profilfoto der verfassenden Person`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_defaultAuthorAltText = () => `Klaviyo Image`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_minRead = () => `Lesedauer in Minuten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogCard_read = () => `Lesen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_days = () => `Tage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_hours = () => `Std.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_minutes = () => `Min.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_seconds = () => `Sek.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_filterBlock_topic = () => `Thema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_save = () => `Speichern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_saved = () => `Gespeichert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseDepartment_openRoles = () => `offene Rollen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_previous = () => `Zurück`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_next = () => `Weiter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_relatedCard_openInANewTab = () => `wird in einer neuen Registerkarte geöffnet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_searchBox_placeholder = () => `Nach Thema oder Stichwort suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articlesPlural = () => `Artikel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articleSingular = () => `Artikel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_label = () => `Von Academy abmelden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_label = () => `My Academy Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_href = () => `/de-de/profile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_label = () => `Bei Academy anmelden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_href = () => `https://www.klaviyo.com/contact-us`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_label = () => `Kontaktiere uns (EN) ↗`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_href = () => `https://www.klaviyo.com/dashboard`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_label = () => `Konto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_label = () => `Anmelden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_href = () => `https://www.klaviyo.com/de/search-all`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_label = () => `Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_anchorLinks_backToTop = () => `Zurück zum Anfang`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_articleTableContents_tableContents = () => `Inhalt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogArticleHero_featureImageAltText = () => `Ausgewähltes Bild`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogCards_viewCategory = () => `Kategorie anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_title = () => `Das Klaviyo-Konzept`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_tagline = () => `Deine eigene Marketingressource`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_days = () => `Tage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_hours = () => `Stunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_minutes = () => `Minuten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_seconds = () => `Sekunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_postTitle = () => `Erste Schritte mit Klaviyo (EN) ↗`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_resource = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_excerpt = () => `Integriere deinen Online-Shop und beginne, mit Klaviyo Nachrichten zu senden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_href = () => `https://academy.klaviyo.com/en-us/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_postTitle = () => `So richtest du SMS in Klaviyo ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_resource = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_excerpt = () => `Erstelle eine Grundlage für erfolgreiches SMS-Marketing.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_href = () => `/hc/de-de/articles/4404274419355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_postTitle = () => `So erstellst und sendest du eine E-Mail-Kampagne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_resource = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_excerpt = () => `Erstelle und sende deine erste E-Mail-Kampagne.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_href = () => `/hc/de-de/articles/115005054847`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_postTitle = () => `Erste Schritte mit Anmeldeformularen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_resource = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_excerpt = () => `Verwende Formulare, um mit deinen Abonnent*innen zu interagieren und mehr Informationen über sie zu sammeln.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_href = () => `/hc/de-de/articles/360026474752`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_postTitle = () => `So nutzt du Flow-KI zum Erstellen von Flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_resource = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_excerpt = () => `Erstelle vollständige Flows im benötigten Umfang durch Eingaben in natürlicher Sprache.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_href = () => `/hc/de-de/articles/26604555031963`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_postTitle = () => `Erste Schritte mit Bewertungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_resource = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_excerpt = () => `Sammle Kundenfeedback und fördere Conversions.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_href = () => `/hc/de-de/articles/15937542819355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuresList_loadMore = () => `Mehr laden`


/**
 * @param {{ year: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_copyright = (params) => `Urheberrecht: © ${params.year} Klaviyo. Alle Rechte vorbehalten.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_privacySettings = () => `Deine Datenschutzeinstellungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headlineEmbedded = () => `Demo anfordern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headline = () => `Fordere eine personalisierte Demo an`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_body = () => `Erfahre bei einer Produktvorstellung und Beratung, wie Klaviyo deinem Unternehmen beim Wachstum helfen kann.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_allRequired = () => `Alle Felder müssen ausgefüllt werden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_button = () => `Demo anfordern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_buttonSubmitting = () => `Wird gesendet …`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_headline = () => `Du musst jetzt nichts mehr tun!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonOne = () => `Alle Funktionen entdecken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonTwo = () => `Marketingressourcen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_headline = () => `Leg noch heute los`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_body = () => `Sende deine erste Kampagne in Minutenschnelle und schalte dein Marketing auf Autopilot – mit gezielten SMS- und E-Mail-Nachrichten, die Umsatz generieren.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_button = () => `Konto erstellen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_buttonSubmitting = () => `Wird gesendet …`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_label = () => `Datenschutzrichtlinie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_href = () => `/de/legal/privacy/privacy-notice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService = () => `Nutzungsbedingungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_acknowledgement = () => `Mit dem Absenden dieses Formulars akzeptierst du die`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService_href = () => `/de/legal/terms-of-service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_and = () => `und`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_network = () => `Deine Anfrage ist aufgrund eines Netzwerkfehlers nicht eingegangen. Bitte versuche es erneut.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_generic = () => `Deine Anfrage ist nicht eingegangen. Bitte versuche es erneut.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_rateLimit = () => `Du hast dich innerhalb kurzer Zeit zu oft angemeldet. Bitte nutze deine bestehenden Konten oder wende dich an den Kundensupport. Danke!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_recaptcha = () => `reCaptcha ist erforderlich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_label = () => `Name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_placeholder = () => `Vollständiger Name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_errors_required = () => `Bitte gib deinen Namen ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_label = () => `E-Mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_placeholder = () => `name@beispiel.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_email = () => `Achte darauf, dass deine E-Mail-Adresse ein einzelnes @ enthält, gefolgt von einer gültigen Domäne (name@beispiel.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_required = () => `Erforderlich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_label = () => `Passwort`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_placeholder = () => `Gib dein Passwort ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_common = () => `Dein Passwort ist nicht individuell genug.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_min = () => `Achte darauf, dass dein Passwort mindestens 8 Zeichen enthält.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_max = () => `Achte darauf, dass dein Passwort nicht länger als 128 Zeichen ist.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_required = () => `Erforderlich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_label = () => `Name des Unternehmens`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_placeholder = () => `Gib hier den Namen deines Unternehmens ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_errors_required = () => `Bitte gib den Namen deines Unternehmens ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_label = () => `Webseite des Unternehmens`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_placeholder = () => `https://beispiel.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_url = () => `Achte darauf, dass die Website deines Unternehmens eine gültige Domäne enthält (https://beispiel.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_required = () => `Erforderlich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_label = () => `Telefonnummer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_placeholder = () => `Gib deine Telefonnummer ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_matches = () => `Achte darauf, dass deine Telefonnummer deine Ortsvorwahl oder Landesvorwahl enthält`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_max = () => `Die Nummer darf höchstens 15 Zeichen lang sein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_required = () => `Erforderlich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_label = () => `Geschätzter Jahresumsatz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_placeholder = () => `Wähle den geschätzten Jahresumsatz aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_underFive = () => `Weniger als 5 Mio. USD`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_five = () => `5 bis 20 Mio. USD`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_twenty = () => `20 bis 400 Mio. USD`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_fourHundred = () => `Über 400 Mio. USD`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_errors_required = () => `Bitte wähle deinen geschätzten Jahresumsatz aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_label = () => `Wie möchtest du Klaviyo nutzen?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_placeholder = () => `Wähle aus, wie du Klaviyo nutzen möchtest`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_ownBusiness = () => `Für mein eigenes Geschäft`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_clientsBusiness = () => `Für das Geschäft meiner Kundschaft`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_errors_required = () => `Bitte wähle aus, wie du Klaviyo nutzen möchtest`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_label = () => `Art des Unternehmens`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_placeholder = () => `Art des Unternehmens auswählen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailGoods = () => `Einzelhandelswaren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailServices = () => `Einzelhandelsdienstleistungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_other = () => `Andere, nicht im Einzelhandel erhältliche Produkte und Dienstleistungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_errors_required = () => `Bitte wähle die Art deines Unternehmens aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_label = () => `Anzahl der Kontakte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_placeholder = () => `Wähle die Anzahl der Kontakte aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_zero = () => `0 bis 999`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_one = () => `1.000 bis 2.999`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_three = () => `3.000 bis 24.999`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_twentyFive = () => `25.000 bis 99.999`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneHundred = () => `100.000 bis 499.999`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_fiveHundred = () => `500.000 bis 1 Mio.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneMillion = () => `Über 1 Mio.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_errors_required = () => `Erforderlich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_label = () => `Welche Produkte interessieren dich? Wähle alle zutreffenden aus.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_placeholder = () => `Produkte auswählen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_email = () => `E-Mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_cdp = () => `CDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_reviews = () => `Bewertungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_mobile_push = () => `Mobile Push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_errors_required = () => `Bitte wähle ein Produkt aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_label = () => `E-Commerce-Plattform`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_placeholder = () => `Wählen deine Plattform aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Magento = () => `Adobe Commerce (Magento)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_BigCommerce = () => `BigCommerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Commercetools = () => `Commercetools`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Nuvemshop = () => `Nuvemshop`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_OpenCart = () => `OpenCart`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_PrestaShop = () => `PrestaShop`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Salesforce = () => `Salesforce Commerce Cloud`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopify = () => `Shopify`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_ShopifyPlus = () => `Shopify Plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopware = () => `Shopware`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_SquareOnline = () => `Square Online`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Wix = () => `Wix Stores`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_WooCommerce = () => `WooCommerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_other = () => `Hier nicht aufgeführte E-Commerce-Plattform`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_custom = () => `Ich habe eine individuelle Lösung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_doesNotApply = () => `Ist für mein Unternehmen nicht relevant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_errors_required = () => `Bitte wähle ein Produkt aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_newsletter_label = () => `Melde dich für die Marketingkommunikation von Klaviyo an, darunter Newsletter, Blogbeiträge, Produktneuigkeiten, Webinare und gezielte Werbung. Über den Link „Abbestellen“ in den E-Mails kannst du dich vom E-Mail-Marketing abmelden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_agency_label = () => `Ich bin eine Agentur, die sich für ihre Kundschaft anmeldet.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_demo_requested_label = () => `Ich wünsche eine Live-Beratung/-Vorstellung.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_label = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_href = () => `/hc/de-de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_currentBreadcrumb = () => `Anfrage zum Kontozugriff`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_articleMetaTitle = () => `Anfrage zum Kontozugriff`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_headline = () => `Hast du Probleme beim Zugriff auf dein Konto?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_subhead = () => `Sende deine Informationen an unser Supportteam. Ein Teammitglied wird sich in Kürze bei dir melden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_email = () => `Achte darauf, dass deine E-Mail-Adresse ein einzelnes @ enthält, gefolgt von einer gültigen Domäne (name@beispiel.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_websiteUrl = () => `Achte darauf, dass die Website deines Unternehmens eine gültige Domäne enthält (https://beispiel.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_issueRecipeients = () => `Bitte gib eine gültige E-Mail-Adresse ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_required = () => `Erforderlich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_label = () => `Problem`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_placeholder = () => `Wähle ein Problem aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_account_disabled = () => `Konto deaktiviert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_forgot_password = () => `Passwort vergessen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_invoice_inquiry = () => `Rechnungsanfrage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_2_step_authentication = () => `Multi-Faktor-Authentifizierung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_device_code = () => `Neuer Gerätecode`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_account_owner = () => `Kontoinhaber*in aktualisieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_label = () => `Name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_placeholder = () => `Gib deinen vollständigen Namen ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_label = () => `Konto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_placeholder = () => `Gib deinen Kontonamen ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_label = () => `E-Mail-Adresse zum Klaviyo-Konto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_placeholder = () => `Gib eine E-Mail-Adresse ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_label = () => `Website-URL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_placeholder = () => `Gib eine Website-URL ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_label = () => `Wobei benötigst du Hilfe?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_placeholder = () => `Beschreibe das Problem`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_label = () => `Weitere Empfänger*innen (optional)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_placeholder = () => `Gib eine E-Mail-Adresse ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_button_label = () => `+ Empfänger*innen hinzufügen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_submit_button_label = () => `Senden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_headline = () => `Deine Anfrage wurde übermittelt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_subhead = () => `Unser Supportteam wird sich so bald wie möglich bei dir melden. Eine Antwort wird an die von dir angegebene(n) E-Mail-Adresse(n) gesendet.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_label = () => `Zur Startseite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_href = () => `/hc/de-de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_glossary_jumpTo = () => `Springen zu`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_searchJobs = () => `Stellen suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_allLocations = () => `Alle Orte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_search = () => `Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_allSystemsOperational = () => `Alle Systeme betriebsbereit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_majorSystemOutage = () => `Größerer Systemausfall`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partialSystemOutage = () => `Teilweiser Systemausfall`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorServiceOutage = () => `Kleinere Dienstunterbrechung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorSystemOutage = () => `Kleinerer Systemausfall`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_degradedSystemService = () => `Verschlechterter Systemdienst`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem = () => `Teilweise verschlechtertes System`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedService = () => `Teilweise verschlechterter Dienst`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance = () => `Dienst wird gewartet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_modal_closeModal = () => `Pop-up schließen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_eyebrow = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_richText = () => `Vernetze dich mit Kolleg*innen, Partner*innen und Klaviyo-Expert*innen, um dich inspirieren zu lassen, Erkenntnisse auszutauschen und Antworten auf deine Fragen zu erhalten.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_label = () => `Community besuchen (EN) ↗`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_href = () => `https://community.klaviyo.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_openInNewTab = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_eyebrow = () => `Live-Schulung (EN) ↗`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_richText = () => `Nimm an einer Live-Sitzung mit Klaviyo-Expert*innen teil, um mehr über Best Practices, die Einrichtung wichtiger Funktionen und mehr zu erfahren.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_label = () => `Jetzt registrieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_href = () => `https://www.klaviyo.com/events/live-training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_openInNewTab = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_eyebrow = () => `Support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_label = () => `Anmelden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_openInNewTab = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_accessSupport = () => `Kontaktiere den Support über dein Konto.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupport = () => `Support per E-Mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAccountTypes = () => `(kostenlose Testversion und kostenpflichtige Konten)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAvailability = () => `Verfügbar 24/7`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistance = () => `Chat- / virtuelle Unterstützung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability = () => `Verfügbarkeit abhängig von Standort und Abonnementtyp`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_logo_label = () => `Gehe zur Klaviyo-Startseite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_label = () => `Gehen Sie zur Klaviyo Power Up-Ressourcenseite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_href = () => `https://www.klaviyo.com/de/customer-resources`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_signUp_button_href = () => `/sign-up`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_label = () => `Demo anfordern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_href = () => `/demo-request`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_productNews = () => `Klaviyo-Produktneuigkeiten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_read = () => `Lesen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_klavioLogo = () => `Klaviyo Logo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_viewAll = () => `Alle anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceCategory = () => `Kategorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceCollection = () => `Sammlung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceStage = () => `Stage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceTopic = () => `Thema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_search = () => `Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_eyebrow = () => `Schätze deinen Preis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_headline = () => `Wie viele aktive Profile hast du?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_startingAt = () => `Ab`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_month = () => `Monat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts = () => `Aktive Profile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contactLimitExceeded = () => `Limit für aktives Profil überschritten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_signUp = () => `Registrieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlyEmailSends = () => `monatlich gesendete E-Mails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlySmsMmsCredits = () => `monatliche SMS/MMS-Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_opensAModal = () => `(Pop-up-Fenster wird geöffnet)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_mobilePush = () => `Mobile-Push-Nachrichten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeCredits = () => `kostenlose monatliche SMS/MMS-Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_includesFees = () => `Einschließlich etwaiger Netzbetreibergebühren für SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_supportToScale = () => `Support beim Wachstum deines Geschäfts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_onboarding = () => `Onboarding für 450 USD/Monat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_csm = () => `Customer Success Manager*in für 1.500 $/Monat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_emailAndChatSupport = () => `E-Mail- und Chat-Support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeSupport = () => `E-Mail-Support für die ersten 60 Tage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_getADemo = () => `Demo anfordern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plusSign = () => `+`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_copy = () => `Steigere die Reichweite deines Marketings, indem du deine Kund*innen per E-Mail und per SMS ansprichst.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_name = () => `E-Mail und SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_copy = () => `Gehe den nächsten Schritt in deinem E-Mail-Marketing – mit einer einfachen Lösung, die umfassende Personalisierung bietet.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_name = () => `E-Mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_copy = () => `Ideal zum Einstieg und zum Testen der Klaviyo-Kundenplattform.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_name = () => `Kostenlos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_buttons_getDemo = () => `Demo anfordern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_richTextBody = () => `Wenn du mehr als 250.000 aktive Profile hast, wende dich bitte an unser Vertriebsteam, um das für dich passende Abonnement zu finden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_headline = () => `Lass uns reden!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_regionName = () => `USA`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntrySms = () => `SMS = 1 Credit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntryMms = () => `MMS = 3 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_regionName = () => `Kanada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntrySms = () => `SMS = 3 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntryMms = () => `MMS = 5 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_regionName = () => `Vereinigtes Königreich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntrySms = () => `SMS = 5 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_regionName = () => `Australien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntrySms = () => `SMS = 4 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_regionName = () => `Neuseeland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntrySms = () => `SMS = 10 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_regionName = () => `Irland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntrySms = () => `SMS = 9 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_regionName = () => `Italien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntrySms = () => `SMS = 7 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_regionName = () => `Frankreich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntrySms = () => `SMS = 7 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_regionName = () => `Deutschland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntrySms = () => `SMS = 12 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_regionName = () => `Niederlande`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntrySms = () => `SMS = 12 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_regionName = () => `Portugal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntrySms = () => `SMS = 3 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_headline = () => `SMS/MMS-Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText1 = () => `Du kannst deine Credits für SMS, MMS oder beides nutzen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText2 = () => `Die Anzahl der Credits für SMS- und MMS-Nachrichten unterscheidet sich je nach Empfängerstandort.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AU = () => `Australien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AT = () => `Österreich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_BE = () => `Belgien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CA = () => `Kanada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DK = () => `Dänemark`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FR = () => `Frankreich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FI = () => `Finnland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DE = () => `Deutschland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IE = () => `Irland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IT = () => `Italien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NL = () => `Niederlande`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NZ = () => `Neuseeland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NO = () => `Norwegen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_BR = () => `Portugal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_GB = () => `Vereinigtes Königreich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_US = () => `Vereinigte Staaten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_ES = () => `Spanien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_SE = () => `Schweden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CH = () => `Schweiz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sendTo = () => `Senden an`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_mms = () => `MMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_maxSends = () => `Max. Sendungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_pricePer = () => `Preis pro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credit = () => `Credit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credits = () => `Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimer = () => `Inklusive Carrier-Gebühren, die geschätzt werden auf`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimerEnd = () => `Der Preis pro SMS/MMS kann je nach Nachrichtenlänge variieren.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_tileList_viewAll = () => `Alle anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_video_playVideo = () => `Video abspielen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_filterTitle = () => `Alle Updates`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_collapseAll = () => `Alles minimieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_clearAll = () => `Alle entfernen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_placeholder = () => `Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_watchQuarterlyRecap = () => `Vierteljahresrückblick ansehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_topic = () => `Thema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_release_type = () => `Art der Veröffentlichung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_benefits = () => `Vorteile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_accounts_billing = () => `Konto und Abrechnung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_analytics = () => `Auswertungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_audience = () => `Zielgruppe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_cdp = () => `Kundendatenplattform`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_campaigns = () => `Kampagnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_deliver_compliance = () => `Zustellbarkeit und Compliance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_email = () => `E-Mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_flows = () => `Flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_integrations = () => `Integrationen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_push_notifications = () => `Push-Nachrichten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_reviews = () => `Bewertungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sign_up_forms = () => `Registrierungsformulare`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_coming_soon = () => `Demnächst verfügbar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_limited_availability = () => `Begrenzte Verfügbarkeit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_gradual_release = () => `Schrittweise Freigabe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_general_availability = () => `Allgemeine Verfügbarkeit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_eyebrow = () => `Seite nicht gefunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_itsPronounced = () => `Es wird so ausgesprochen:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_bodyCopy = () => `Nicht das, wonach du gesucht hast? Gehe zur <a href="/email-marketing">E-Mail-Seite</a>, zur <a href="/sms-marketing">SMS-Seite</a> oder zur <a href="/">Startseite</a>.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_button = () => `Zur Startseite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_pageTitle = () => `Stellen suchen | Karriere bei Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_headline = () => `Stellen suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_recentJobs = () => `Zuletzt angesehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_savedJobs = () => `Gespeicherte Stellen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_home = () => `Startseite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_searchJobs = () => `Stellen suchen`


/**
 * @param {{ start: NonNullable<unknown>, end: NonNullable<unknown>, total: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_searchResults = (params) => `Angezeigt werden <strong>${params.start}</strong> - <strong>${params.end}</strong> von <strong>${params.total}</strong> passenden Stellen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResults = () => `Es wurden leider keine Stellen gefunden, die deinen Kriterien entsprechen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResultsReset = () => `Bitte versuche es mit anderen Suchkriterien oder klicke, um <a href="#" onclick="window.location.href='/careers/search-jobs'">alle unsere offenen Stellen anzuzeigen</a>.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_legend = () => `Stellen filtern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywords = () => `Stichwörter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywordsPlaceholder = () => `Stellen suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_country = () => `Land`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_location = () => `Ort`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_team = () => `Team`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_applyFilters = () => `Filter anwenden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_clearFilters = () => `Filter entfernen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_community_answered = () => `Frage beantwortet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardMinutes = () => `minuten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularMinute = () => `minute`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardHours = () => `stunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularHour = () => `stunde`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_headline = () => `Alle Ressourcen durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_placeholder = () => `Nach Thema oder Stichwort suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_toggleLabel = () => `Anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelTop = () => `Top-Suchergebnisse`


/**
 * @param {{ ' y ': NonNullable<unknown>, ' x ': NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelYofX = (params) => `Angezeigt werden ${params[' y ']} von ${params[' x ']}`


/**
 * @param {{ ' index ': NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewAllResults = (params) => `Alle ${params[' index ']} Ergebnisse anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewMoreResults = () => `Mehr anzeigen`


/**
 * @param {{ ' query ': NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsTitle = (params) => `Für „${params[' query ']}“ konnten wir keine Ergebnisse finden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsSubTitle = () => `Überprüfe die Rechtschreibung oder probiere es mit einer anderen Suche.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearchesTitle = () => `Vorgeschlagene Suchanfragen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search1 = () => `Erste Schritte mit Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search2 = () => `Erste Schritte mit SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search3 = () => `Erste Schritte mit Klaviyo CDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search4 = () => `Erste Schritte mit Formularen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search5 = () => `Black Friday Cyber Monday`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search6 = () => `Erstelle einen Inhaltskalender in Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_collapseAll = () => `Alles minimieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_clearAll = () => `Alles entfernen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_resource = () => `Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_allResources = () => `Alle Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_academy = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_community = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_developers = () => `Entwickler*innen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_helpCenter = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_klaviyoHome = () => `Marketingressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_accounts_billing = () => `Konto und Abrechnung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_analytics = () => `Auswertungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_audience = () => `Zielgruppe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_cdp = () => `CDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_campaigns = () => `Kampagnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_deliver_compliance = () => `Zustellbarkeit und Compliance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_email = () => `E-Mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_flows = () => `Flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_integrations = () => `Integrationen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_push_notifications = () => `Push-Nachrichten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_reviews = () => `Bewertungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sign_up_forms = () => `Registrierungsformulare`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_title = () => `Klaviyo-Sitemap`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_header = () => `Kategorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_postsByThisAuthor = () => `Beiträge dieser Person`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_openInANewTab = () => `werden in einer neuen Registerkarte geöffnet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_featured = () => `Ausgewählte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_articles = () => `Artikel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_customer = () => `Kunde`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_industry = () => `Branche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_platform = () => `Plattform`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_general = () => `Notiz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_warning = () => `Warnung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_requirements = () => `Anforderungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_siteName = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_title = () => `Klaviyo Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_metaDesc = () => `Durchsuche unsere Wissensdatenbank, um Antworten auf häufige Fragen zu finden. Durchsuche unsere Artikel, das Community-Forum, Live- und aufgezeichnete Schulungen und mehr, um alles über die Nutzung von Klaviyo zu erfahren und unsere Best Practices zu entdecken.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_opengraphSiteName = () => `Klaviyo Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_account = () => `Anfrage zum Kontozugriff`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_article = () => `Artikel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_category = () => `Kategorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_section = () => `Abschnitt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_search = () => `Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_name = () => `Ausgewählte Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_slug = () => `/hc/de-de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_searchHeadline = () => `Wie können wir dir heute bei der Suche helfen?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_moreCardHeadline = () => `Mehr von Klaviyo entdecken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_label = () => `Zum Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_href = () => `/hc/de-de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_titleText = () => `Nicht gefunden | Klaviyo Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_headline = () => `Ausgewählte Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_subhead = () => `Entdecke Leitfäden, Kurse und Materialien, um dein Geschäft mit Klaviyo auszubauen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL20R80_headline = () => `Nach Thema suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL30R70_headline = () => `Nach Thema suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_category_topArticles = () => `Top-Artikel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperText = () => `Keine Ergebnisse für`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperSuggestion = () => `Probiere es mit einer anderen Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsInstantSearch = () => `Keine Ergebnisse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_helpCenter_headline = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_community_headline = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_developers_headline = () => `Entwickler*innen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_academy_headline = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_marketing_headline = () => `Marketingressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_viewAll = () => `Alle anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_title = () => `Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_opengraphSiteName = () => `Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_metaDesc = () => `Du erfährst, wie du dein Geschäft mit Klaviyo ausbauen kannst. Beginne mit unseren Kursen, Zertifizierungen und Leitfäden, die dir helfen, Klaviyo erfolgreich zu nutzen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_bestPractices = () => `Best practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_collection = () => `Zertifikat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_course = () => `Kurse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_lesson = () => `Lektion`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_search = () => `Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_registered = () => `Registriert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_completed = () => `Abgeschlossen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_viewed = () => `Gesehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_startingText = () => `In Arbeit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_endingText = () => `Abgeschlossen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_label = () => `Zur Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_href = () => `/de-de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_titleText = () => `Nicht gefunden | Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_headline = () => `Mach dich fit mit der Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_subhead = () => `Lerne die Strategien und Best Practices kennen, um den Umsatz zu maximieren und deine Geschäftsziele zu erreichen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_button_label = () => `Alle Ressourcen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_button_href = () => `/de-de/search`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_headline = () => `Neu und bemerkenswert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_subhead = () => `Informiere dich über die neuesten Kurse, Leitfäden und Schulungen von unserem globalen Expertenteam.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_title = () => `Best-Practice-Leitfäden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_excerpt = () => `Lerne die besten Marketing-Strategien kennen, um Kunden zu gewinnen, Kundenbindung zu automatisieren und den Umsatz zu steigern.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_button_label = () => `Best Practices anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_button_href = () => `/de-de/best-practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_title = () => `Klaviyo auf YouTube`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_excerpt = () => `Schau dir Video-Tutorials an, um relevante Tipps und Experteneinblicke zu erhalten, um dein Geschäft mit Klaviyo auszubauen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_button_label = () => `Besuche die YouTube-Bibliothek`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_button_href = () => `https://www.youtube.com/channel/UCLLurTBYufj95_5zTnJISnA`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_title = () => `Anatomie eines Flows: Welcome Flow`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_excerpt = () => `Erstelle einen personalisierten Welcome Flow und lerne Best Practices kennen, um die Bindungen mit Abonnenten zu stärken.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_button_label = () => `Jetzt lernen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_button_href = () => `/de-de/courses/anatomy-of-a-flow-welcome-series/1881997`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_headline = () => `Entscheide, wie du lernen möchtest`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_subhead = () => `Wähle aus einer Vielzahl von Optionen, die zu deinem Zeitplan und Lernstil passen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_title = () => `Erste Schritte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_content = () => `<p>Befolge die Schritt-für-Schritt-Anleitungen, um mit neue Kanäle, Funktionen und Produkte auszuprobieren.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_buttons_label = () => `Alle Leitfäden für die ersten Schritte anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_buttons_href = () => `/de-de/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_title = () => `Best Practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_content = () => `<p>Baue dein Geschäft aus und optimiere dein Marketing mit unseren Top-Strategien.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_buttons_label = () => `Alle Best Practices anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_buttons_href = () => `/de-de/best-practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_title = () => `Kurzanleitungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_content = () => `<p>Finde Antworten in 10—Minuten oder weniger mit praktischen, kurzen Anleitungen.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_buttons_label = () => `Alle Kurzanleitungen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_buttons_href = () => `/de-de/search?select=Quick+guide|Under+10+minutes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_title = () => `Live-Schulungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_content = () => `<p>Nimm an Live-Sitzungen mit Klaviyo Expert*innen teil und erhalte Antworten auf deine Fragen in Echtzeit.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_buttons_label = () => `Alle Live-Schulungen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_buttons_href = () => `/de-de/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_title = () => `Kurse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_content = () => `<p>Erfahre, wie du Marketing-Strategien mit On-Demand-Lerninhalten und praktischen Beispielen in deinem Unternehmen effektiv anwenden kannst.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_buttons_label = () => `Alle Kurse anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_buttons_href = () => `/de-de/search?select=Course`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_title = () => `Zertifikat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_content = () => `<p>Tauche mit einer Reihe von Kursen tiefer in ein Thema ein. Teste dein Wissen mit einer Abschlussprüfung, um ein Abschlusszertifikat zu erhalten.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_buttons_label = () => `Alle Zertifikate anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_buttons_href = () => `/de-de/search?select=Certificate`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_title = () => `Empfohlene Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_button_label = () => `Alle Ressourcen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_button_href = () => `/de-de/search`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_coursePath = () => `/de-de/courses/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_collectionPath = () => `/de-de/collections/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_title = () => `Beginne mit den Grundlagen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_button_label = () => `Alle Leitfäden für die ersten Schritte anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_button_href = () => `/de-de/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_description = () => `Erfahre, wie du dein E-Commerce-Ökosystem integrierst, Abonnenten vermehrst und mit Klaviyo Nachrichten versenden kannst.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_divider = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_href = () => `/de-de/courses/getting-started-with-klaviyo/1459179`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_pill = () => `Kurse, Erste Schritte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_title = () => `Erste Schritte mit Anmeldeformularen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_description = () => `Erfahre, was Segmente sind, wie du sie erstellst und wie du Segmente verwendest, um gezieltere Marketingkampagnen zu senden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_divider = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_href = () => `/de-de/courses/getting-started-with-sms/1411601`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_pill = () => `Kurse, Erste Schritte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_title = () => `Erste Schritte mit Segmenten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_description = () => `Klaviyo Kampagnen – bist du nicht weitergekommen? Werde zum Profi mit Insider-Tipps von 143.000 Marken in unserem Kurs zu Kampagnen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_divider = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_href = () => `/de-de/courses/getting-started-with-klaviyo-cdp/1759043`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_pill = () => `Erste Schritte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_title = () => `Erste Schritte mit Kampagnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_description = () => `Lerne die Grundlagen des Flows kennen, erstelle deinen ersten automatisierten Flow in Klaviyo und befolge Best Practices, um deinen Umsatz zu steigern.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_divider = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_href = () => `/de-de/courses/develop-a-klaviyo-reviews-strategy/1630005`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_pill = () => `Erste Schritte, Kurs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_title = () => `Erste Schritte mit Flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_title = () => `Registriere dich für eine Live-Schulung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_subhead = () => `Lerne von unserem Expertenteam in Echtzeit.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_button_label = () => `Alle Live-Schulungen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_button_href = () => `/de-de/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_description = () => `Aufschlüsselung E-Mail Zustellbarkeit mit Strategien zur Bewertung und Verbesserung deiner Performance.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_href = () => `https://www.bigmarker.com/klaviyo-customer-education/strategy-session-understand-email-deliverability`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_pill = () => `Live-Schulung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_title = () => `Grundlegendes zur E-Mail-Zustellbarkeit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_description = () => `Lerne Designprinzipien kennen, um Traffic und Conversion zu steigern.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Strategy-session-Design-emails-that-convert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_pill = () => `Live-Schulung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_title = () => `Entwerfe E-Mails, die konvertieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_description = () => `Verstehe wie wertvoll SMS als Kanal sind und wie du sie in deinen Workflow integrieren kannst.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Strategy-session-SMS-marketing-strategy-North-America`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_pill = () => `Live-Schulung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_title = () => `SMS-Marketing-Strategie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_description = () => `Stelle deine strategischen Fragen an die Expert*innen von Klaviyo in Echtzeit.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Office-hours-Getting-started-with-Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_pill = () => `Live-Schulung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_title = () => `Sprechstunde`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_headline = () => `Das sagen unsere Kunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_text = () => `Die Beispiele. Es ist immer hilfreich zu sehen, wie die Expert*innen das machen. Dank dieser Schulungen habe ich gelernt, mich in Klaviyo zurechtzufinden und damit effektiver zu arbeiten <3`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_button_label = () => `Melde dich für eine Schulung an`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_button_href = () => `/de-de/search?select=live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_size = () => `groß`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_text = () => `Die Beispiele aus der Praxis, die Schritt-für-Schritt-Anleitung und die Best Practices waren ERSTAUNLICH. Die Webinare von Klaviyo lohnen sich für mich am meisten.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_button_label = () => `Melde dich für eine Schulung an`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_button_href = () => `/de-de/search?select=live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_size = () => `klein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_text = () => `Optimistisch, direkt und prägnant. Klar und direkt. Meine Zeit ist wertvoll, und das wurde respektiert. Tolle Demo!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_button_label = () => `Melde dich für eine Schulung an`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_button_href = () => `/de-de/search?select=live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_size = () => `klein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_text = () => `Ich fand die einzelnen Sprecher wirklich interessant. Alle waren kompetent und konnten die Inhalte auf spannende Weise vermitteln. Ich fand die Erkenntnisse sehr hilfreich und schätzte sorgfältige Planung dieser Schulungen sehr.  Danke Klaviyo! Am Ende der Schulung schwirrte mein Kopf vor Ideen für meine Kunden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_button_label = () => `Melde dich für eine Schulung an`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_button_href = () => `/de-de/search?select=live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_size = () => `groß`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_home = () => `Startseite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_searchAll = () => `Alle durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_blog = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_sitemap = () => `Sitemap`


export { organisms_bfcmHero_eyebrow } from "./en-US.js"

export { organisms_bfcmHero_headlineFilter_thisBfcm } from "./en-US.js"

export { atoms_singleLineForm_primaryButton } from "./en-US.js"

export { atoms_singleLineForm_placeholderText } from "./en-US.js"

export { atoms_singleLineForm_error } from "./en-US.js"

export { navigation_ecosystem_ctas_academy_logOut_href } from "./en-US.js"

export { navigation_ecosystem_ctas_academy_myCredentials_label } from "./en-US.js"

export { navigation_ecosystem_ctas_academy_myCredentials_href } from "./en-US.js"

export { navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label } from "./en-US.js"

export { navigation_ecosystem_ctas_academy_signIn_href } from "./en-US.js"

export { navigation_platformActions_support_href } from "./en-US.js"

export { navigation_platformActions_support_label } from "./en-US.js"

export { organisms_articleTableContents_overview } from "./en-US.js"

export { organisms_bfcmHero_headline } from "./en-US.js"

export { organisms_bfcmHero_headlineFilter_iAm } from "./en-US.js"

export { organisms_bfcmHero_headlineFilter_iWantTo } from "./en-US.js"

export { organisms_blogCards_viewAll } from "./en-US.js"

export { organisms_blogSearchHero_placeholder } from "./en-US.js"

export { organisms_blogSearchHero_customSearchHeadline } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_submit } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_loading } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_examplePrompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productLaunch } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productPromotion } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productUpdate } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_storewideSale } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_announcement } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_issueType_setting_up_new_device } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_info } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_reason } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_company_test_url } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_profile_names } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_last_login_date } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_other_emails } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_recent_invoice } from "./en-US.js"

export { organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder } from "./en-US.js"

export { organisms_moreCards_card1_icon_iconName } from "./en-US.js"

export { organisms_moreCards_card2_icon_iconName } from "./en-US.js"

export { organisms_moreCards_card3_icon_iconName } from "./en-US.js"

export { organisms_moreCards_card3_richText_template } from "./en-US.js"

export { organisms_navigationCategorySelection_viewAllButton_text } from "./en-US.js"

export { organisms_navigationCategorySelection_viewLessButton_text } from "./en-US.js"

export { organisms_post_filter_read_more } from "./en-US.js"

export { organisms_pricing_per_month } from "./en-US.js"

export { organisms_pricing_contactSales } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_name } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_recommended } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_smsSubText } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_mmsSubText } from "./en-US.js"

export { organisms_pricing_plans_email_per_month } from "./en-US.js"

export { organisms_pricing_plans_email_emails_label } from "./en-US.js"

export { organisms_pricing_plans_free_subtext_top } from "./en-US.js"

export { organisms_pricing_plans_free_subtext_bottom } from "./en-US.js"

export { organisms_pricing_plans_expandable_button } from "./en-US.js"

export { organisms_pricing_plans_collapsible_button } from "./en-US.js"

export { organisms_pricing_plans_paidCardContent_above250kContacts } from "./en-US.js"

export { organisms_pricing_plans_paidCardContent_below250Contacts } from "./en-US.js"

export { organisms_pricing_plans_platform_headline } from "./en-US.js"

export { organisms_pricing_plans_platform_cdp_subTextInfoHeader } from "./en-US.js"

export { organisms_pricing_plans_platform_cdp_subTextInfo } from "./en-US.js"

export { organisms_pricing_plans_platform_cdp_subText } from "./en-US.js"

export { organisms_pricing_contacts_slider_headline } from "./en-US.js"

export { organisms_pricing_contacts_slider_subText } from "./en-US.js"

export { organisms_pricing_contacts_slider_subTextInfo } from "./en-US.js"

export { organisms_pricing_credits_slider_headline } from "./en-US.js"

export { organisms_pricing_credits_slider_subText } from "./en-US.js"

export { organisms_pricing_credits_slider_subTextInfo } from "./en-US.js"

export { organisms_pricing_calculator_headline } from "./en-US.js"

export { organisms_pricing_calculator_service_type } from "./en-US.js"

export { organisms_pricing_calculator_destination } from "./en-US.js"

export { organisms_pricing_calculator_sms_limit } from "./en-US.js"

export { organisms_pricing_calculator_mms_limit } from "./en-US.js"

export { organisms_pricing_calculator_pricePerSend } from "./en-US.js"

export { organisms_searchBar_placeholder_post } from "./en-US.js"

export { organisms_searchBar_placeholder_page } from "./en-US.js"

export { organisms_searchBar_placeholder_case_study } from "./en-US.js"

export { organisms_searchBar_placeholder_compare_page } from "./en-US.js"

export { organisms_searchBar_placeholder_marketing_resource } from "./en-US.js"

export { organisms_searchBar_placeholder_newsroom_article } from "./en-US.js"

export { organisms_searchBar_placeholder_partner_page } from "./en-US.js"

export { organisms_searchBar_placeholder_podcast_page } from "./en-US.js"

export { organisms_searchBar_placeholder_product_update } from "./en-US.js"

export { organisms_searchBar_placeholder_solutions_page } from "./en-US.js"

export { organisms_searchBar_placeholder_success_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_post } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_case_study } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_product_update } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_marketing_resource } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_newsroom_article } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_podcast_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_compare_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_partner_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_solutions_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_success_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_category } from "./en-US.js"

export { academy_pages_bestPractices_headline } from "./en-US.js"

export { academy_pages_bestPractices_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_headline } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_subhead } from "./en-US.js"

export { roiCalculator_results_headlineText } from "./en-US.js"

export { roiCalculator_results_revenuePerYear } from "./en-US.js"

export { roiCalculator_results_subHeadlineText } from "./en-US.js"

export { roiCalculator_results_newSubscribers } from "./en-US.js"

export { roiCalculator_results_campaigns } from "./en-US.js"

export { roiCalculator_results_automatedFlows } from "./en-US.js"

export { roiCalculator_results_signupText } from "./en-US.js"

export { roiCalculator_results_getStartedButton } from "./en-US.js"

export { roiCalculator_results_talkToSales } from "./en-US.js"

export { roiCalculator_results_invalidRoi } from "./en-US.js"

export { roiCalculator_results_freeTier } from "./en-US.js"

export { roiCalculator_form_brandText } from "./en-US.js"

export { roiCalculator_form_fieldsRequired } from "./en-US.js"

export { roiCalculator_form_channelsUsed } from "./en-US.js"

export { roiCalculator_form_toggleEmail } from "./en-US.js"

export { roiCalculator_form_toggleEmailAndSms } from "./en-US.js"

export { roiCalculator_form_inputActiveProfiles } from "./en-US.js"

export { roiCalculator_form_inputEnterActiveProfiles } from "./en-US.js"

export { roiCalculator_form_inputMonthlyWebVisitors } from "./en-US.js"

export { roiCalculator_form_inputEnterMonthlyWebVisitors } from "./en-US.js"

export { roiCalculator_form_inputAverageOrderValue } from "./en-US.js"

export { roiCalculator_form_inputEnterAverageOrderValue } from "./en-US.js"

export { roiCalculator_form_inputOrdersPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterOrdersPerMonth } from "./en-US.js"

export { roiCalculator_form_inputCampaignsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterCampaignsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputFlowsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterFlowsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputSmsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterSmsPerMonth } from "./en-US.js"

export { roiCalculator_form_roiButton } from "./en-US.js"

export { roiCalculator_form_inputPrefix } from "./en-US.js"

export { academy_pages_cred_landing_hero_headline } from "./en-US.js"

export { academy_pages_cred_landing_hero_subhead } from "./en-US.js"

export { academy_pages_cred_landing_cta_header } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_collapse } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_expand } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_title } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_subtitle } from "./en-US.js"

export { academy_pages_cred_landing_cta2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_body } from "./en-US.js"

export { academy_pages_cred_landing_34 } from "./en-US.js"

export { academy_pages_cred_faq_headline } from "./en-US.js"

export { academy_pages_cred_faq_subhead } from "./en-US.js"

export { academy_pages_cred_faq_row0_title } from "./en-US.js"

export { academy_pages_cred_faq_row0_content } from "./en-US.js"

export { academy_pages_cred_faq_row1_title } from "./en-US.js"

export { academy_pages_cred_faq_row1_content } from "./en-US.js"

export { academy_pages_cred_faq_row2_title } from "./en-US.js"

export { academy_pages_cred_faq_row2_content } from "./en-US.js"

export { academy_pages_cred_faq_row3_title } from "./en-US.js"

export { academy_pages_cred_faq_row3_content } from "./en-US.js"

export { academy_pages_cred_faq_row4_title } from "./en-US.js"

export { academy_pages_cred_faq_row4_content } from "./en-US.js"

export { academy_pages_cred_faq_row5_title } from "./en-US.js"

export { academy_pages_cred_faq_row5_content } from "./en-US.js"

export { academy_pages_cred_faq_row6_title } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_4 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_5 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_6 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_3 } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_eyebrow } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_link } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_link } from "./en-US.js"

export { academy_partner_tag } from "./en-US.js"

export { organisms_pricing_rates_regionItlay_regionName } from "./en-US.js"

export { organisms_forms_legal_marketingCommunicationsConsent } from "./en-US.js"

export { organisms_forms_legal_agreeToTermsOfService } from "./en-US.js"

export { organisms_forms_legal_agreeTermsLinkText } from "./en-US.js"

export { organisms_forms_legal_agreeToPartnerCodeOfConduct } from "./en-US.js"

export { organisms_forms_legal_codeOfConduct_href } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_buttons_getDemo } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_richTextBody } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_headline } from "./en-US.js"

export { helpCenter_templates_search_results } from "./en-US.js"

export { academy_courseStatus_registed } from "./en-US.js"